const MEDIA_ITEMS = [
  {
    title: '「暗夜猎魔人」动画化PV公开',
    desc: '人气国漫《暗夜猎魔人：觉醒》正式宣布动画化，首支预告片震撼发布。',
    img: 'https://readdy.ai/api/search-image?query=Exciting%20anime%20promotional%20visual%20for%20fantasy%20series%2C%20warrior%20character%20in%20dynamic%20action%20pose%2C%20dramatic%20orange%20and%20red%20lighting%2C%20Chinese%20animation%20style%2C%20cinematic%20composition%2C%20epic%20atmosphere&width=800&height=450&seq=media-01&orientation=landscape',
    tag: 'PV预告',
  },
  {
    title: '韩漫推荐：「秘密花园」阅读量突破千万',
    desc: '治愈系韩漫《秘密花园的秘密》全平台阅读量突破千万，成为年度现象级作品。',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20garden%20scene%20with%20soft%20sunlight%20for%20webtoon%20promotion%2C%20Korean%20illustration%20style%2C%20pastel%20green%20and%20cream%20tones%2C%20peaceful%20healing%20atmosphere%2C%20cinematic%20wide%20shot&width=800&height=450&seq=media-02&orientation=landscape',
    tag: '热门资讯',
  },
  {
    title: '虫虫漫画网 X 春季漫画节合作企划',
    desc: '虫虫漫画网联合多家漫画平台举办春季漫画节，推出限时免费阅读活动。',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20manga%20festival%20event%20banner%20with%20various%20manga%20characters%20and%20covers%2C%20celebratory%20atmosphere%2C%20warm%20spring%20colors%2C%20pink%20and%20yellow%20accents%2C%20clean%20promotional%20design&width=800&height=450&seq=media-03&orientation=landscape',
    tag: '活动',
  },
  {
    title: '新锐国漫作者专访：从零到百万读者',
    desc: '对话《狐妖大人请留步》作者，分享从新人到百万读者的创作心路历程。',
    img: 'https://readdy.ai/api/search-image?query=Artist%20studio%20workspace%20with%20drawing%20tablet%20and%20manga%20sketches%2C%20warm%20cozy%20lighting%2C%20creative%20atmosphere%2C%20Chinese%20manhua%20artist%20workspace%2C%20professional%20yet%20personal%20setting&width=800&height=450&seq=media-04&orientation=landscape',
    tag: '作者专访',
  },
  {
    title: '日漫秋季新番速递：不可错过的5部作品',
    desc: '盘点今秋最值得期待的日漫新番，从奇幻冒险到校园恋爱一网打尽。',
    img: 'https://readdy.ai/api/search-image?query=Autumn%20themed%20anime%20promotional%20visual%20with%20maple%20leaves%2C%20various%20manga%20characters%20collage%2C%20warm%20orange%20and%20gold%20tones%2C%20Japanese%20anime%20style%2C%20exciting%20preview%20atmosphere&width=800&height=450&seq=media-05&orientation=landscape',
    tag: '新番速递',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            漫画画廊
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            <strong>虫虫漫画网</strong>精彩资讯与视觉内容展示
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {MEDIA_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`虫虫漫画网 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-[10px] font-medium bg-background-50/90 text-foreground-800 rounded-full">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading line-clamp-1">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}